import type { UseQueryResult } from "@tanstack/react-query";
import type { SuccessFetchListResponse } from "@/services/api";
import type { CommentRead } from "@/schemas/comments";

/** Builds a query-shaped object for static comment lists (no API fetch). */
export function staticCommentsToQuery(
  items: CommentRead[],
  isLoading: boolean,
): UseQueryResult<SuccessFetchListResponse<CommentRead>> {
  return {
    data: { items, count: items.length, last_item: undefined },
    isPending: isLoading,
    isLoading,
    isFetching: isLoading,
  } as UseQueryResult<SuccessFetchListResponse<CommentRead>>;
}
